import gql from 'graphql-tag';

export const AFTER_TAX_AVERAGE_ANNUAL_TOTAL_RETURNS = gql`
    query AfterTaxReturns($ticker: String!) {
        mutualFund(ticker: $ticker) {
            inceptionDate
            standardPerformanceReturns {
                returnsAfterTaxesOnDistribution {
                    asOfDate
                    oneYearReturn
                    threeYearReturn
                    fiveYearReturn
                    tenYearReturn
                    sinceInceptionReturn
                }
                returnsAfterTaxesOnDistributionAndSales {
                    asOfDate
                    oneYearReturn
                    threeYearReturn
                    fiveYearReturn
                    tenYearReturn
                    sinceInceptionReturn
                }
            }
        }
    }
`;
